

import Vue from 'vue'
import i18n from '@/i18n';
const vm = new Vue({ i18n });

export default {
    install(Vue, option) {
        Vue.prototype.$validate = new (function () {
            const DataValid = function (data) {
                if (data !== undefined && data !== null && data !== '') {
                    if (typeof data === 'object') {
                        return Object.keys(data).length > 0
                    } else if (Array.isArray(data)) {
                        return data.length > 0
                    }

                    if (data.length > 0) {
                        return data.trim().length > 0
                    }
                    return true;

                } else {
                    return false
                }
            }

            const regex = {
                email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                // phone: /^[2-9][0-9]{7}$/,
                phone: /^(\+?)[0-9]{2,18}$/i,
                number: /^[0-9]+$/i,
                floating: /^[0-9]+([.]?[0-9]{1,2})?$/i,
                // floating: /^[0-9]+([.]?[0-9]{1})?$/i,
                floatingWithoutLimit: /^[0-9]+([.]?[0-9]+)?$/i,
                negativeNumber: /^[-]?[0-9]+$/i,
                negativeFloating: /^[-]?[0-9]+([.]?[0-9]+)?$/i,
                blogSlug: /^[\u4e00-\u9fff\u3400-\u4dff\uf900-\ufaffA-za-z0-9-_]+$/i,
                hkid4Letter: /^[A-Z]{1,2}[0-9]{4}$/,
                date: /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
                regexIdNum: /^[a-zA-Z0-9]{8,9}$/i,
                hkPhone: /^(^[2|3|4|5|6|7|8|9])+([0-9]{7})$/,
                hkMobile: /^[3-9][0-9]{7}$/,
                twPhone: /^(^[1-9])+([0-9]{8})$/,
                macauPhone: /^([0-9]{8})$/,
                chinaPhone: /^(^[1])+([0-9]{10})$/,
                chinName: /^[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F\u3400-\u4DBF\u4E00-\u9FFF]{2,40}$/,
                engName: /^[a-zA-Z\s.]{2,40}$/,
                password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                username: /^[a-zA-Z0-9_-]+$/
            }

            this.DataValid = data => {
                return DataValid(data);
            }

            this.required = value => {
                if (DataValid(value) && typeof value === 'string') {
                    return value.trim().length > 0
                }

                return DataValid(value);
            }

            this.regex = (name, value) => {
                if (regex[name] !== undefined) {
                    return regex[name].test(value);
                } else {
                    return new RegExp(name, 'i').test(value);
                }
            }

            this.regexNumber = (value) => {
                return regex.number.test(value);
            }

            this.regexFloating = (value) => {
                return regex.floatingWithoutLimit.test(value);
            }

            this.regexDateStr = (value) => {
                const valid = regex.date.test(value);
                if (!valid) {
                    return false;
                }

                const year = parseInt(value.substring(0, 4));
                const month = parseInt(value.substring(5, 7));
                const date = parseInt(value.substring(8, 10));

                if (month < 1 || month > 12) {
                    return false;
                }

                const daysInMonths = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
                if (date < 1 || date > daysInMonths[month - 1]) {
                    return false;
                }
              
                const datetime = new Date(year, month - 1, date);
                if (datetime.getFullYear() !== year || (datetime.getMonth() + 1) !== month || datetime.getDate() !== date) {
                    return false;
                }

                return true;
            }

            this.isNumber = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                return regex.number.test(value) || vm.$t('form.numericInv');
            }

            this.isFloating = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                return regex.floating.test(value) || vm.$t('form.numericInv');
            }

            this.isPhoneNumber = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                return regex.phone.test(value) || vm.$t('form.phoneInv')
            }
            this.isMobile = (value, code, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                if (code === '852') {
                    return regex.hkMobile.test(value) || vm.$t('form.phoneInv')
                } else if (code === '86') {
                    return regex.chinaPhone.test(value) || vm.$t('form.phoneInv')
                } else if (code === '853') {
                    return regex.macauPhone.test(value) || vm.$t('form.phoneInv')
                }

                return regex.phone.test(value) || vm.$t('form.phoneInv')
            }

            this.isEmail = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                return regex.email.test(value) || vm.$t('form.emailInv')
            }

            this.isEngName = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                return regex.engName.test(value) || vm.$t('form.engNameInv')
            }

            this.isChinName = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                return regex.chinName.test(value) || vm.$t('form.chiNameInv')
            }

            this.isUsername = (value, allowEmpty = false) => {
                if (!DataValid(value)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                return regex.username.test(value) || vm.$t('form.usernameInv');
            }

            const checkDoubleFileExtension = (fileName) => {
                const extension = fileName.match(/\.(.+)$/)[1];

                if (extension.split(".").length !== 1) {
                    return true;
                }

                return false;
            }
            const imgSizeCheck = (file) => {
                return new Promise((resolve) => {
                    var dimenMinW = 0,
                        dimenMinH = 0,
                        dimenMaxW = 5472,
                        dimenMaxH = 5472;
                    var reader = new FileReader();
                    reader.onload = function () {
                        var image = new Image();
                        image.src = reader.result;
                        image.onload = function () {
                            var height = this.height;
                            var width = this.width;

                            if (
                                (dimenMinW > 0 && width < dimenMinW) ||
                                (dimenMinH > 0 && height < dimenMinH) ||
                                (dimenMaxW > 0 && width > dimenMaxW) ||
                                (dimenMaxH > 0 && height > dimenMaxH)
                            ) {
                                resolve(false);
                            } else {
                                // file loaded sucessfully
                                resolve(true);
                            }
                            image.onerror = function (error) {
                                // file failed to load
                                resolve(false);
                            };
                        };
                    };
                    reader.onerror = function (error) {
                        // file failed to load
                        resolve(false);
                    };
                    reader.readAsDataURL(file);
                });
            }
            const uploadExtCheck = (name, mimeType, acceptType) => {
                const fileExt = "." + name.split(".").pop().toLowerCase();

                const allowed = acceptType.split(",");
                return allowed.includes(fileExt) && allowed.includes(mimeType);
            }

            this.validateFileInput = (file, acceptType) => {
                return new Promise(async (resolve) => {
                    if (!file) {
                        resolve('message.uploadRequired');
                    } else {
                        if (file.type.indexOf("image") > -1) {
                            const check = await imgSizeCheck(file);
                            if (!check) {
                                resolve('message.uploadImageSize');
                            }

                            if (file.size > 1024 * 1024 * 8) {
                                resolve('message.uploadImageCapacity');
                            }
                        } else if (file.type.indexOf("application") > -1) {
                            if (file.size > 1024 * 1024 * 10) {
                                resolve('message.uploadDocCapacity');
                            }
                        }

                        if (!uploadExtCheck(file.name.split(".").pop(), file.type, acceptType)) {
                            resolve('message.uploadTypeError');
                        }

                        resolve(true);
                    }
                });
            }


            this.isDateLess = function (d1, d2) {
                if (d1 && d2) {
                    if (d1.getFullYear() < d2.getFullYear()) {
                        return true;
                    } else if (d1.getFullYear() === d2.getFullYear()) {
                        if (d1.getMonth() < d2.getMonth()) {
                            return true;
                        } else if (d1.getMonth() === d2.getMonth()) {
                            if (d1.getDate() < d2.getDate()) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
        
                return d1 === d2;
            }

            this.isDateGreater = function (d1, d2) {
                if (d1 && d2) {
                    if (d1.getFullYear() > d2.getFullYear()) {
                        return true;
                    } else if (d1.getFullYear() === d2.getFullYear()) {
                        if (d1.getMonth() > d2.getMonth()) {
                            return true;
                        } else if (d1.getMonth() === d2.getMonth()) {
                            if (d1.getDate() > d2.getDate()) {
                                return true;
                            }
                        }
                    }
                    return false;
                }
        
                return d1 === d2;
            }

            this.isDateEqual = function (d1, d2) {
                if (d1 && d2) {
                    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
                }
        
                return d1 === d2;
            }


            const checkHKID = function (str) {
                var validChar = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        
                // length length
                if (str.length < 8) return false;
        
                // handling bracket
                if (str.charAt(str.length - 3) == '(' && str.charAt(str.length - 1) == ')') {
                    str = str.substring(0, str.length - 3) + str.charAt(str.length - 2);
                }
        
                str = str.toUpperCase();
                // regular expression to check pattern and split
                var hkidRegex = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/;
                var matchArray = str.match(hkidRegex);
        
                // not match, return false
                if (matchArray == null) return false;
        
                // the character part, numeric part and check digit part
                var charPart = matchArray[1];
                var numPart = matchArray[2];
                var checkDigit = matchArray[3];
        
                // calculate the checksum for character part
                var checkSum = 0;
                if (charPart.length == 2) {
                    checkSum += 9 * (10 + validChar.indexOf(charPart.charAt(0)));
                    checkSum += 8 * (10 + validChar.indexOf(charPart.charAt(1)));
                } else {
                    checkSum += 9 * 36;
                    checkSum += 8 * (10 + validChar.indexOf(charPart));
                }
        
                // calculate the checksum for numeric part
                for (var i = 0, j = 7; i < numPart.length; i++, j--) {
                    checkSum += j * numPart.charAt(i);
                }
        
                // verify the check digit
                var remaining = checkSum % 11;
                var verify = remaining == 0 ? 0 : 11 - remaining;
                return verify == checkDigit || (verify == 10 && checkDigit == 'A');
            }
            this.isIdNumber = function(str, type, allowEmpty = false) {
                if (!DataValid(str)) {
                    if (allowEmpty) {
                        return true;
                    } else {
                        return vm.$t('form.required');
                    }
                }

                if (type === 'hkid') {
                    return checkHKID(str) || vm.$t('form.hkidInv');
                } else {
                    return /^[a-zA-Z0-9]+$/.test(str) || vm.$t('form.passportInv');
                }
            }
        })()
    }
}